import { GeolocationContent } from '@shared/components/Geolocation';
import { GeolocationField } from '@shared/data/entity/fields/GeolocationField';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: GeolocationField;
}

export function GeolocationCollectionViewField({ field }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer fieldType={field.fieldType}>
      <GeolocationContent showUserName={true} geolocation={field.geolocation} collapsed />
    </CardCollectionViewFieldContainer>
  );
}
